import React from "react";

import "./Style/Loader.css";

import WbsLogo from "../../img/wbs-group-logo.png";

const Loader = (): JSX.Element => {
  return (
    <div className="wbs-loader-wrapper">
      <div className="wbs-loader-img-wrapper">
        <img src={WbsLogo} alt="" width="230px"></img>
      </div>

      <div className="wbs-loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
